// src/models/vendedorModel.js

import pb from '../lib/pocketbase';

export async function getVendedores(page, perPage) {
  return await pb.collection('vendedor').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false // Desactiva la auto-cancelación
  });
}

export async function createVendedor(vendedor) {
  return await pb.collection('vendedor').create(vendedor);
}

export async function updateVendedor(id, vendedor) {
  return await pb.collection('vendedor').update(id, vendedor);
}

export async function deleteVendedor(id) {
  return await pb.collection('vendedor').delete(id);
}

export async function getVendedorAtributos(id = null) {
  try {
    const result = await pb.collection('atributo_vendedor').getFullList({
      expand: 'vendedor,atributo', // Expand the relationships
      filter: `vendedor="${id}"`, // Correct filter syntax
    });

    // Transform the data
    const vendedorAtributos = result.map((item) => {
      const vendedor = item.expand.vendedor;
      const atributo = item.expand.atributo;

      return {
        atributo: atributo,
        valor: item.valor,
      };
    });

    return vendedorAtributos; // Optional: return the data for further use
  } catch (error) {
    console.error('Error retrieving data:', error);
  }
}